import React, { useState, useEffect } from 'react';
import { Card, Table, Badge, Button, Form, Modal, Row, Col } from 'react-bootstrap';
import { getPaymentMethodMappings, getUsers, getPaymentMethods, createPaymentMethodMapping, updatePaymentMethodMappingStatus, deletePaymentMethodMapping } from '../../services/admin';
import PageTitle from '../../Component/Comman/PageTitle';

const PaymentMethodMapping = () => {
    const [mappings, setMappings] = useState([]);
    const [users, setUsers] = useState([]);
    const [paymentMethods, setPaymentMethods] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const [formData, setFormData] = useState({
        userId: '',
        paymentMethodId: '',
        status: 'active'
    });

    useEffect(() => {
        fetchMappings();
        fetchUsers();
        fetchPaymentMethods();
    }, []);

    const fetchMappings = async () => {
        try {
            setLoading(true);
            const response = await getPaymentMethodMappings();
            if (response.success) {
                setMappings(response.data?.mappings || response.data || []);
            }
        } catch (error) {
            console.error('Error fetching mappings:', error);
        } finally {
            setLoading(false);
        }
    };

    const fetchUsers = async () => {
        try {
            const response = await getUsers({ page: 1, limit: 1000 });
            const usersData = response.data?.users || response.data || [];
            setUsers(usersData);
        } catch (error) {
            console.error('Error fetching users:', error);
        }
    };

    const fetchPaymentMethods = async () => {
        try {
            const response = await getPaymentMethods();
            if (response.success) {
                setPaymentMethods(response.data || []);
            }
        } catch (error) {
            console.error('Error fetching payment methods:', error);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            await createPaymentMethodMapping(formData);
            alert('Mapping created successfully');
            setShowModal(false);
            setFormData({ userId: '', paymentMethodId: '', status: 'active' });
            fetchMappings();
        } catch (error) {
            alert(error.message || 'Failed to create mapping');
        }
    };

    if (loading) {
        return (
            <div className="container-xxl">
                <div className="d-flex justify-content-center align-items-center min-vh-50">
                    <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="container-xxl">
            <PageTitle pagetitle="Payment Method Mappings" sidebutton={true} />
            <div className="row">
                <div className="col-lg-12">
                    <Card>
                        <Card.Header className="d-flex justify-content-between align-items-center">
                            <Card.Title>User Payment Method Mappings</Card.Title>
                            <Button variant="primary" onClick={() => setShowModal(true)}>
                                Create Mapping
                            </Button>
                        </Card.Header>
                        <Card.Body>
                            <div className="table-responsive">
                                <Table responsive>
                                    <thead>
                                        <tr>
                                            <th>User</th>
                                            <th>Payment Method</th>
                                            <th>Status</th>
                                            <th>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {mappings.length === 0 ? (
                                            <tr>
                                                <td colSpan="4" className="text-center">No mappings found</td>
                                            </tr>
                                        ) : (
                                            mappings.map((mapping) => (
                                                <tr key={mapping._id}>
                                                    <td>
                                                        <div>
                                                            <strong>{mapping.user?.name || 'N/A'}</strong>
                                                            <div className="text-muted">
                                                                <small>{mapping.user?.email || 'N/A'}</small>
                                                                <br />
                                                                <small>{mapping.user?.mobileNumber || 'N/A'}</small>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div>
                                                            <strong>{mapping.paymentMethod?.bankName || mapping.paymentMethod?.accountHolderName || 'N/A'}</strong>
                                                            <div className="text-muted">
                                                                <small>A/C: {mapping.paymentMethod?.accountNumber || 'N/A'}</small>
                                                                <br />
                                                                <small>IFSC: {mapping.paymentMethod?.ifscCode || 'N/A'}</small>
                                                                {mapping.paymentMethod?.upiId && (
                                                                    <>
                                                                        <br />
                                                                        <small>UPI: {mapping.paymentMethod.upiId}</small>
                                                                    </>
                                                                )}
                                                                {mapping.paymentMethod?.cryptoAddress && (
                                                                    <>
                                                                        <br />
                                                                        <small>Crypto: {mapping.paymentMethod.cryptoAddress} ({mapping.paymentMethod.network || 'N/A'})</small>
                                                                    </>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <Badge bg={mapping.status === 'active' ? 'success' : 'danger'}>
                                                            {mapping.status || '-'}
                                                        </Badge>
                                                    </td>
                                                    <td>
                                                        <Button
                                                            variant="danger"
                                                            size="sm"
                                                            onClick={() => {
                                                                if (window.confirm('Delete this mapping?')) {
                                                                    deletePaymentMethodMapping(mapping._id).then(() => {
                                                                        alert('Deleted successfully');
                                                                        fetchMappings();
                                                                    });
                                                                }
                                                            }}
                                                        >
                                                            Delete
                                                        </Button>
                                                    </td>
                                                </tr>
                                            ))
                                        )}
                                    </tbody>
                                </Table>
                            </div>
                        </Card.Body>
                    </Card>
                </div>
            </div>

            <Modal show={showModal} onHide={() => setShowModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Create Payment Method Mapping</Modal.Title>
                </Modal.Header>
                <Form onSubmit={handleSubmit}>
                    <Modal.Body>
                        <Form.Group className="mb-3">
                            <Form.Label>User</Form.Label>
                            <Form.Select
                                value={formData.userId}
                                onChange={(e) => setFormData({ ...formData, userId: e.target.value })}
                                required
                            >
                                <option value="">Select User</option>
                                {users.map(user => (
                                    <option key={user._id} value={user._id}>
                                        {user.name || user.email}
                                    </option>
                                ))}
                            </Form.Select>
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Payment Method</Form.Label>
                            <Form.Select
                                value={formData.paymentMethodId}
                                onChange={(e) => setFormData({ ...formData, paymentMethodId: e.target.value })}
                                required
                            >
                                <option value="">Select Payment Method</option>
                                {paymentMethods.map(method => (
                                    <option key={method._id} value={method._id}>
                                        {method.bankName || method.accountHolderName || 'N/A'} - {method.accountNumber || 'N/A'}
                                    </option>
                                ))}
                            </Form.Select>
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Status</Form.Label>
                            <Form.Select
                                value={formData.status}
                                onChange={(e) => setFormData({ ...formData, status: e.target.value })}
                                required
                            >
                                <option value="active">Active</option>
                                <option value="inactive">Inactive</option>
                            </Form.Select>
                        </Form.Group>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => setShowModal(false)}>
                            Cancel
                        </Button>
                        <Button variant="primary" type="submit">
                            Create
                        </Button>
                    </Modal.Footer>
                </Form>
            </Modal>
        </div>
    );
};

export default PaymentMethodMapping;

